import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Link from "@material-ui/core/Link";

import Toolbar from "@material-ui/core/Toolbar";
import { withStyles } from "@material-ui/core/styles";

function Covid19Header(props) {
  const {
    classes: { root, toolbar, topSub, link },
  } = props;

  return (
    <AppBar
      position="sticky"
      style={{ background: "#AF9FF1" }}
      classes={{ root }}
    >
      <Toolbar classes={{ root: toolbar }}>
        <Grid item xs={12} className={topSub}>
          {`Introducing Qwell Concierge- the ultimate resource for Concierge Medical.`}
          <p>&nbsp;</p>
          <Link
            href={process.env.REACT_APP_HOMEPAGE_URL+"/concierge-pricing"}
            className={link}
          >
            Secure your membership today
          </Link>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}

Covid19Header.propTypes = {
  providerName: PropTypes.string,
  specialtyShortName: PropTypes.string,
  cityShortName: PropTypes.string,
  insuranceShortName: PropTypes.string,
  history: PropTypes.object,
};

const styles = {
  root: {
    width: "100%",
    boxShadow: "none",
    zIndex:'0'
  },
  toolbar: {
    width: "100%",
  },
  topSub: {
    color: "#002952",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
  },
  link: {
    borderBottom: "1px dashed white",
    textDecoration: "none",
    color: "#002952",
    "&:hover": {
      opacity: "0.7",
    },
    "&:visited": {
      color: "#002952",
    },
  },
};

export default withStyles(styles)(Covid19Header);
